import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";

// Import reducers and slices
import { auth, current_user } from "./reducers/auth";
import ticketReducer from "./reducers/tickets";
import customerReducer from "./reducers/customers";
import travelItemReducer from "./reducers/travelitems";
import flightsReducer from "./slices/flightSlice";

// Configure persist settings
const persistConfig = {
  key: "root",
  storage,
};

// Combine reducers
const rootReducer = combineReducers({
  auth,
  current_user,
  tickets: ticketReducer, // Renamed key for consistency
  customers: customerReducer, // Renamed key for consistency
  travelItems: travelItemReducer, // Renamed key for consistency
  flights: flightsReducer, // Added flights slice
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // To avoid errors with redux-persist
    }),
});

// Create the persistor
export const persistor = persistStore(store);

export default store;
